import React from "react";
import { useStatsActivityOrders } from "../../api/hooks/stats";
import dayjs from "dayjs";
import { DATE_TIME_FORMAT } from "../../utils/date";

function ActivityList() {
  const { data: activitiesRes, isLoading: isLoadingActivities } =
    useStatsActivityOrders({
      params: {},
    });

  if (isLoadingActivities) {
    return <div>Loading...</div>;
  }

  return (
    <div className="w-full rounded-lg border border-gray-300 bg-gray-100 p-4 shadow-md">
      <h2 className="mb-2 text-lg font-bold">Recent Activities</h2>
      <ul>
        {activitiesRes?.map((activity) => {
          const {
            _id = "",
            createdBy = {},
            status = "",
            order = {},
            createdAt,
          } = activity;
          return (
            <li
              key={_id}
              className="border-b border-gray-300 py-2 last:border-b-0"
            >
              <div className="flex items-center gap-2">
                <span className="w-1/6 text-sm text-gray-400">
                  {dayjs(createdAt).format(DATE_TIME_FORMAT)}
                </span>

                <span className="text-gray-600">
                  <b>{createdBy.name}</b> <b>{status}</b> {order.referenceId}
                  {", "}
                  {order.poNumber ? `Ref Po: ${order.poNumber}` : ""}
                </span>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default ActivityList;
